import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgJusIa(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.127 2.247c.459 0 .899.193 1.206.547l.01.01.01.009.008.01c.305.362.435.834.353 1.305l-.001.001-3.002 17.057-.001.008c-.168.825-.926 1.253-1.547 1.253H8.39a1.68 1.68 0 0 1-.467-.063 1.525 1.525 0 0 1-.953-.743l-.002-.004-3.739-7.066h.001a1.578 1.578 0 0 1 .037-1.577c.293-.48.81-.775 1.375-.775h3.62l1.515-8.644.001-.002a1.61 1.61 0 0 1 1.576-1.326h7.773Zm-2.794 19.886.014-.001h-.014ZM8.017 22.1Zm8.498-.007.02-.006-.02.006Zm.174-.067.036-.017-.036.017Zm.186-.102.028-.019-.028.019Zm.074-.053.037-.028-.037.028Zm.081-.066Zm.071-.07Zm.07-.08.039-.052-.04.052Zm.125-.188c.01-.018.017-.037.026-.056l-.026.056ZM8.842 20.46h6.65l-3.306-6.246H9.942l-1.1 6.246ZM7.26 17.944l.659-3.739H5.284l1.976 3.739Zm3.034-5.715h2.13c.518 0 .995.253 1.295.66l.117.184v.003l2.468 4.659 2.37-13.492h-6.983l-1.397 7.986Zm-6.867 2.057Zm-.048-.15Zm-.032-.161Zm-.01-.154Zm.01-.162Zm.032-.163Zm.239-.481a1.346 1.346 0 0 0-.174.286 1.275 1.275 0 0 0 .174-.286Zm.11-.12Zm.114-.102Zm.131-.088Zm.132-.07Zm.147-.054c-.027.009-.054.016-.08.027.026-.01.053-.018.08-.027Zm.076-.023-.008.002c.05-.013.1-.023.152-.03l-.144.028Zm16.107-8.68Zm-.003-.12Zm-.016-.13Zm-.032-.137Zm-.04-.12Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgJusIa)
